import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static values = { pass: Boolean, copiedText: String };

  connect() {
    if (this.passValue) {
      this.openModal();
    }
  }

  openModal() {
    $("#finish").modal("show");
  }

  async copyToClipboard(event) {
    event.preventDefault();
    const textArea = this.element.querySelector("textarea");
    const text = textArea.value;

    if (navigator.clipboard && navigator.clipboard.writeText) {
      try {
        await navigator.clipboard.writeText(text);
        this.showCopiedMessage(event.target);
      } catch (error) {
        console.error(error);
      }
    } else {
      textArea.select();
      document.execCommand("copy");
      window.getSelection().removeAllRanges();
      this.showCopiedMessage(event.target);
    }
  }

  showCopiedMessage(button) {
    button.textContent = this.copiedTextValue;
  }
}